import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Ingredient
      {record ? `: ${record.name}` : ''}
    </span>
  );
};
